import React, { useEffect } from 'react';
import { PIXEL_ID } from '../utils/metaPixel';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    }) as MetaPixelFunction;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-119" data-mp="ri4htjs7w31n">
      <img src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} height="1" width="1" alt="" style={{
      display: 'none'
    }} data-id="element-120" data-mp="18fi2917kulsw" />
    </noscript>;
}